export const Strings = {
  auth: {
    logIn: "Sign In",
    signIn: "Log In",
    forgotPassword: "Forgot Password?",
    doNotHave: "Don’t have an account?",
    signUp: "Sign up",
    forgotPasswordPage: "Forgot Password",
    updatePassword: "Update Password",
    enterEmailTo: "Enter email to change your password",
    emailAddress: "Email Address",
    password: "Password",
    alreadyHaveIn: "Already have an account?",
    conformNewPassword: "Confirm New Password",
    email: "Email",
    name: "Name",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone",
    newPassword: "New Password",
    yourNewPassword:
      "Your new password must be different from previous used passwords.",
    conformPassword: "confirm password",
  },
  authPopup: {
    logIn: "Login",
    reSendOtp: "Resend OTP",
    otp: "OTP",
    pleaseSelectBrands: "Please Select a brand",
    selectBrand: "Select Brand",
    selectBudget: "Select Budget",
    selectModal: "Select Model",
    selectCarsBrands: "Select Your Car Brand",
    carsRegistrationsNumber: "Car Registration Number *",
    name: "Name*",
    burCars: "Buy Car",
    sellCars: "Sell Car",
    sellBuyCars: "Sell/Buy Car Online",
    welcomeBackLogin:
      "Welcome back! Login using your registered mobile number or email.",
    phoneNumber: "Phone Number",
    enterPhoneNumber: "Enter phone number",
    emailOptional: "Email (Optional)",
    email: "Email*",
    enterEmail: "Enter email",
    byContinuingYou:
      "By Continuing, you agree to our Terms of service and Privacy Policy.We’ll send an OTP to verify your number.",
    pleaseEnterOtp: "Enter Your OTP To Login",
    beAnInvestor: "Be an Investor",
    requestReceived: "Request Received",
    thankYouFor:
      "Thank you for showing interest to invest in Premium Used Cars at Kaizen Motor. Please speak to the DEALER PRINCIPAL, Contact +91 99000 14550.",
    joinKaizen: " Join Kaizen Motor in the premium automotive market.",
  },
  headersSteps: {
    vehicleSelections: "Vehicle Selection",
    dateAndTime: "Date & Time",
    yourDetails: "Your Details",
    locations: "Location",
    confirmations: "Confirmation",
  },
  navBar: {
    home: "Home",
    products: "Products",
    exploreCars: "Explore Cars",
    testDrive: "Test Drive",
    categories: "Categories",
    contactUs: "Contact us",
    buyCars: "Buy Cars",
    sellCars: "Sell Cars",
    beAnInvestor: "Be an Investor",
  },
  myProfile: {
    editProfile: "Edit Profile",
    mobileNumber: "Mobile Number",
  },
  testDrive: {
    validDriver: "Valid driver",
    sSilence: "s license",
    selectLocation: " Select Location",
    viewInMap: "View on Map",
    bookYourTest: "Book Your Test Drive",
    completeTheFollowing:
      "Complete the following steps to schedule your personalized test drive experience.",
    selectTime: "Select Time",
    selectDate: "Select Date",
    testYourDetails: "Test Drive Details",
    vehicle: "Vehicle",
    dateAndTime: "Date & Time",
    location: "Location",
    contactInformation: "Contact Information",
    whatDoBring: "What to bring to your test drive:",
    noCarsFound: "No cars found",
  },
  buy: {
    bookingInfo: "Booking  Info",
    pleaseEnterYour: "Please enter your booking info",
    phoneNumber: "Phone Number",
    address: "Address",
    townCity: "Town / City",
    productSummary: "Product Summary",
    subTotal: "Subtotal",
    tax: "Tax",
    discount: "Discount",
    paymentMethods: " Payment Method",
    pleaseEnterYourPayment: "Please enter your payment method",
    creditCard: "Credit Card",
    cardNumber: "Card Number",
    expirationDate: "Expiration Date",
    cvc: "CVC",
    cardHolder: "Card Holder",
    upi: "UPI",
    confirmation: "Confirmation",
    iAgreeWith:
      "I agree with sending me Marketing and newsletter emails. No spam, promised!",
    iAgreeWithOur: "I agree with our terms and conditions and privacy policy.",
    allYourData: "All your data are safe.",
    overallPriceAnd: "Overall price and includes discount",
    step1of4: "Step 1 of 4",
    step3of4: "Step 3 of 4",
    weAreGettingTo:
      "We are getting to the end. Just few clicks and your order is ready",
    weAreUsingThe: "We are using the most advanced security to protect you.",
    reviewer: (number: number | string) => `${number}+ Reviewer`,
    totalPrice: "Total Price",
    requestReceived: "Request Received",
    thankYouFor:
      "Thank You for showing interest on PREMIUM USED CAR at Kaizen Motor. To block and book the vehicle, please get in touch with +91 99000 14550",
  },
  productListPage: {
    relevance: "Relevance",
    relevanceValues: "relevance",
    priceLowToHigh: "Price : Low to High",
    priceLow: "lowToHigh",
    priceHighToLow: "Price : High to Low",
    priceHigh: "highToLow",
    kmDrivenLow: "KM Driven - Low to High",
    kmLow: "lessDriven",
    yearNewToOld: "Year - New to Old",
    yearNew: "newToOld",
    usedCars: "Used Cars",
    newCars: "New Cars",
    discoverTheMost:
      " Discover the most searched and viewed cars in India. From daily commuters to family favourites, check out the top-rated vehicles based on actual demand and reviews.",
    entries: "entries",
    noProductsFound: "No products found.",
  },
  common: {
    and: " and ",
    kaizenMoter: " Kaizen Motor",
    hyphen: "-",
    townAndCity: "Town / City",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    drivingLicence: "Driving Licence Number",
    iConsentTo:
      ". I consent to being contacted regarding my test drive request.",
    state: "State",
    termsAndConditions: "Terms & Conditions",
    iAgreeTo: "I agree to the",
    pageNotFound: "Page not found!",
    sorryCanNotFoundPage:
      "Sorry, we couldn’t find the page you’re looking for.",
    success: "Success",
    failed: "Failed",
    selected: (prefix: string) => (prefix ? `${prefix} selected` : "selected"),
    noRecord: "No Record",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    search: "Search",
    projects: "Projects",
    allProjects: "All Projects",
    allStatus: "All Status",
    resetFilters: "Reset Filters",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone : ",
    phoneNumber: "Phone Number",
    email: "Email : ",
    emailAddress: "Email Address",
    statusHeading: "Status : ",
    city: "City : ",
    country: "Country : ",
    address: "Address",
    zipcode: "Zip code",
    view: "View",
    close: "Close",
    goBack: "Go Back",
    print: "Print",
    selectAll: "Select All",
    addAnotherSpool: "Add Another Spool",
    dragAndDrop: "Drag & Drop or Choose File to import",
    selectProject: "Select Project :",
    selectLineNumber: "Select Line Number",
    saving: "Saving",
    confirm: "Confirm",
    assign: "Assign",
    clickToScan: "Click to Scan QR Code",
    send: "Send",
    na: "N/A",
    noBugFound: "No Bug Found",
    add: "Add",
    noQrGenerated: "No QR Generated",
    clickHere: "Click Here",
    lineId: "Line ID :",
    noRecordFound: "No record found",
  },
  button: {
    details: "Details",
    yes: "Yes",
    no: "No",
    sentOtp: "Send OTP",
    cancel: "Cancel",
    confirmAndGenerate: "Confirm & Generate Code",
    addInventory: "Add Inventory",
    continue: "Continue",
    resetPassword: "Reset Password",
    conformBooking: "Confirm Booking",
    returnToHomePage: "Return to Homepage",
    back: "Back",
    payNow: "Pay Now",
    bookTestDrive: "Book Test Drive",
    bookNow: "Book Now",
    saveDetails: "Save Details",
    checkProducts: "Check Products",
    buyNow: "Buy Now",
    search: "Search",
    next: "Next",
    getOTP: "Get OTP",
    getMyCarsValue: "Get my Car’s Value",
    submit: "Submit",
    goBack: "Go Back",
    seeAll: "See All",
    sellMyCar: "Sell My Car",
    shopNow: "Shop Now",
    bookMyOrders: "Book My Orders",
    maybeLater: "Maybe Later",
    callNow: "Call Now",
    close: "Close",
  },
  users: {
    userManagement: "User Management",
    viewAndManage: "View and manage all user in the system.",
    status: "Status",
    addUser: "Add User",
    allRoles: "All Roles",
    estimator: "Estimator",
    detailer: "Detailer",
    fabShop: "Fab Shop",
    fieldInstaller: "Field Installer",
    welder: "Welder",
    areYouSure: "Are You Sure?",
    doYouWantToDelete: "Do You want to delete this user ?",
    enterYourPersonalEmail:
      "Enter your personal email address (not your work email).",
    officialEmailIsAuto:
      "Official Email is auto-generated and cannot be changed.",
    editUser: "Edit User",
  },
  purchaser: {
    addPurchaser: "Add Purchaser",
    purchaserManagement: "Purchaser Management",
    viewAndManage: "View and manage all purchaser in the system.",
    doYouWantDelete: "Do you want to delete this Purchaser",
  },
  rowActions: {
    edit: "Edit",
    delete: "Delete",
    view: "View",
  },
  categrey: {
    noWheelersFound: (selectedVehicle: string) =>
      `No ${selectedVehicle} wheelers found.`,
    exploreAWide:
      "Explore a wide range of car categories tailored to your needs –from compact hatchbacks\n and powerful SUVs to fuel-efficient sedans. Find the right car for your lifestyle, budget, and\n purpose, all in one place.",
  },
  header: {
    login: "Login",
  },
  footer: {
    sendAMessage: "Send A Message",
    allRights: "Kaizen Motor. All rights reserved.",
    category: "Category",
    termsAndCondition: "Terms & Conditions",
    privacyPolicy: "Privacy & Policy",
    products: "Products",
    contactUs: "Contact Us",
    kozienMotor: "Kaizen Motor",
    ourVisionIs:
      "Our vision is to provide convenience and help increase your sales business.",
  },
  validation: {
    fieldRequired: (field: string) => `Please enter the ${field}`,
    selectionRequired: (field: string) => `Please select the ${field}`,
    notAllowedWhiteSpace: (field: string) =>
      `${field} should not start with whitespace or be empty`,
    invalidEmail: "Please enter the valid email address",
    pleaseConfirmTheShipment: "Please Confirm the Shipment ",
    passwordNotMatch: "Conform Password password Not Match",
    validEmail: "Please enter a valid email address",
    pleaseSelectA: "Please select a valid location.",
    pleaseSelectALocations: "Please select a location to continue.",
    pleaseSelectAVehicle: "Please select a vehicle to continue.",
    pleaseSelectATime: "Please select a time slot.",
    pleaseSelectADate: "Please select a date.",
    pleaseCheckTerms: "Please check Terms and Conditions",
    drivingLicenseNumber: "driving License Number",
  },
  fields: {
    email: "Email",
    password: "Password",
    role: "Role",
    spoolId: "Spool ID",
    cadFile: "CAD File",
    pleaseSelectAt: "Please select at least one Material",
    firstName: "First Name",
    lastName: " Last Name",
    phoneNumber: "Phone Number",
    personalEmail: "Personal Email",
    city: "City",
    state: "State",
    zipcode: "Zipcode",
    country: "Country",
    status: "Status",
    address: "Address",
    notes: "Notes/Description",
    materialName: "Material Name",
    size: "Size",
    quantity: "Quantity",
    description: "Description",
  },
  sideBar: {
    dashboard: "Dashboard",
    estimators: "Estimators",
    detailers: "Detailers",
    users: "Users",
    projects: "Projects",
    purchaser: "Purchaser",
    inventory: "Inventory",
    estimatorsList: "Estimators List",
    projectsList: "Projects List",
    estimatedList: "Estimated List",
    assignedSpool: "Assigned Spool",
    fabricationShop: "Fabrication Shop",
    scanAndInstall: "Scan & Install",
    shipmentAndReceiving: "Shipment & Receiving",
    installationReports: "Installation Reports",
  },
  loginScreen: {
    login: "Login",
    welcome: " Welcome!",
    loginInYourAccount: "Login to your Account",
    role: "Role",
    emailAddress: "Email Address",
    password: "Password",
    forgotPassword: "Forgot Password",
  },
  forgotPasswordScreen: {
    forgotPassword: "Forgot Password",
    returnToLogin: "Return to Login",
    resetPassword: "Reset Password",
    emailAddress: "Email Address",
    enterEmail: "Enter Email to change your password",
  },
  resetPasswordScreen: {
    save: "Save",
    confirmNewPassword: "Confirm New Password",
    newPassword: "New Password",
    resetPassword: "Reset Password",
    yourNewPassword:
      "Your new password must be different from previous used passwords.",
    passwordDoNotMatch: "Passwords do not match.",
  },
  projects: {
    projectsManagement: "Projects Management",
    viewAndManage: "View and manage all Projects in the system.",
    addProject: "Add Project",
    pleaseUploadCSVFile:
      "Please upload a clear CSV file  of the Estimator. This helps us verify and link records accurately. Your data is secure and kept private",
    uploadFile: "Upload CSV file of your Estimator ",
    fileUploaded: "File Uploaded",
    yourFileHasBeen: "Your file has been successfully uploaded",
    materialRequestForm: "Material Request Form",
    updateProject: "Update Project",
  },
  dashboard: {
    spoolId: "Spool ID",
    activeProjects: "Active Projects",
    inProgressProject: "In Progress Project",
    completeProjects: "Complete Projects",
    totalFabShop: "Total Fab shop",
    totalEstimator: "Total Estimators",
    totalDetailer: "Total Detailer",
    totalFieldInstaller: "Total Field Installer",
    welcomeToSite:
      " Welcome to SiteTrack — Your Construction Progress Assistant",
    trackSpoolsIssue: "Track spools, issues, installations and more.",
    lineNumber: "Line Number",
    projectOverview: "Project Overview",
    spoolStatus: "Spool Status",
    material: "Material",
    uploadedBy: "Uploaded By",
    lineNumbers: "Line Numbers",
  },
  inventory: {
    inventoryManagement: "Inventory Management",
    viewAndManage: "View and manage all inventory in the system.",
    addInventory: "Add Inventory",
  },
  home: {
    showing: "Showing",
    noCategoriesFound: "No categories found",
    entries: "entries",
    newCars: "New Cars",
    usedCars: "Used Cars",
    twoWheelers: "Two Wheelers",
    testDrive: "Test Drive",
    searchSelectAnd: "Search, select and buy a car",
    easily: " Easily",
    carsOnePlace: "10,000+ Cars. One Place.",
    fromNewRides:
      "From new rides to trusted used cars — find your perfect match anywhere in India.",
    explore: "Explore",
    selectAVehicle: "Select a vehicle group",
    whyUseUs: "WHY CHOOSE US",
    weOfferThe: "We offer the best experience with our deals",
    bestPriceGuarantee: "Best price guarantee",
    finedALower: "Find a lower price? We’ll refund you 100% of the difference.",
    premiumCars: "Premium Cars",
    getPremiumCards: "Get Premium Brand New Cars of your choice",
    hourCarDelivery: "24 hour car delivery",
    bookYourCar:
      "Book your car anytime and we will deliver it directly to you.",
    technicalSupport: "24/7 technical support",
    haveAQuestion:
      "Have a question? Contact cars support any time when you have problem.",
    ourPremiumServices: "Our Premium Services",
    handpickedTopCondition:
      "Handpicked top-condition vehicles, white-glove support, and complete peace of mind — because you deserve nothing less.",
    hoursSupport: "24 Hours Support",
    reliableAssistance:
      "Reliable assistance anytime through calls, bookings, and support. Every issue gets resolved quickly through our dedicated customer service team.",
    weSupportYou: " We support you all hours of the day, ",
    everyVehicleIs:
      "Every vehicle passes through quality inspection and verification. Every ride stays protected through valid insurance and trusted safety standards.",
    qualifiedAssurance: "Qualified Assurance",
    allCarsHave: "All cars have a valid insurance.",
    gpsOnCars: "GPS on Cars",
    driverSmarter:
      "Every car includes smart GPS navigation for seamless travel. Every journey becomes easier through accurate routes and real-time location tracking.",
    whyKaizen: "Why “Kaizen” for Used Luxury?",
    continuousImprovement:
      "Continuous Improvement. Every car improves through our refurbishment. Every process improves through customer feedback. Every ownership improves through our ecosystem.",
    allCarsAre: "All cars are equipped with GPS navigation system.",
    hatchback: "Hatchback",
    petrol: "Petrol",
    powerSteering: "Power Steering",
    viewDetails: "View Details",
    allVehicles: "All Vehicles",
    sedan: "Sedan",
    electric: "Electric",
    pickup: "Pickup",
    suv: "Suv",
    minivan: "Minivan",
    useCars: "Used Cars",
    seeAll: "See all",
    brandNewCars: "Brand New Cars",
    findYourRide: "Find Your Ride, Sell with Ease",
    browseByPrice: "Browse by Price",
    noVehiclesInThisRange: "No vehicles in this range",
    freshRecommendation: "Fresh Recommendation",
    enterCarRegistrationNumber: "Enter Car Registration Number",
    latestCar: "Latest Car",
    mostSearchedCars: "Most Searched Cars",
    popularCars: "Popular Cars",
    sellMyCar: "Sell My Car",
    checkCarValuation: "Check Car Valuation",
  },
  heading: {
    ourVision: "Our Vision and Mission",
    aboutUs: "About Us",
    categoriesForYou: "Categories For You",
    products: "Products",
    filter: "Filter",
  },
  table: {
    selected: "selected",
  },
  cards: {
    Location: "Location",
    totalLineNumbers: "Total Line Numbers",
    uploadedOn: "Uploaded on:",
    status: "Status:",
  },
  categories: {
    categories: "Categories",
    exploreByBrands: "Explore by Brands",
    browseByWheeler: "Browse by Wheeler",
    twoWheeler: "Two Wheeler",
    fourWheeler: "Four Wheeler",
    loadingVehicles: "Loading vehicles...",
    errorLoadingVehicles: "Error loading vehicles",
    matchingWheelers: "Matching Wheelers",
  },
  productDetail: {
    shortsBy: "Sort by : ",
    typeCar: "Type Car",
    capacity: "Capacity",
    steering: "Steering",
    fuelType: "Fuel Type",
    specification: "Specification",
    moreLikeThis: "More like this",
    recommendedForYou: "Recommended for you",
    brand: "Brand",
    model: "Model",
    year: "Year",
    variant: "Variant",
    transmission: "Transmission",
    distanceTravelled: "Distance Travelled",
  },
  confirmation: {
    proofOfInsurance: "Proof of insurance",
    areYouSure: "Are you sure you want to logout?",
  },
  userDropDownMenu: {
    editProfile: "Edit Profile",
    myOrders: "My Orders",
    logout: "Logout",
  },
  filters: {
    priceRange: "Price Range",
    clear: "Clear",
    brands: "Brands",
    min: "Min",
    max: "Max",
    year: "Year",
    kmDriven: "KM Driven",
    fuelType: "Fuel Type",
    transmission: "Transmission",
    color: "Color",
  },
  sellCarStepper: {
    brand: "Brand",
    year: "Year",
    model: "Model",
    variant: "Variant",
    kMsDriven: "KMs Driven",
    sellingTime: "Selling Time",
    carInfo: "Car Info",
    images: "Images",
    mobileNo: "Mobile No.",
  },
  eligibilityCard: {
    eligibilityCriteria: "Eligibility Criteria",
    serviceAvailableOnly: "Service available only in Bangalore",
    only1stOwnerCars: "Only 1st Owner cars are eligible",
  },
  step: {
    brand: {
      egDL34AC4564: "(e.g DL34AC4564)",
      carNumber: "Car Number",
      enterYourCarNumber: "Enter Your Car Number",
      pleaseProvideYourVehicle:
        "Please provide your vehicle registration number",
      selectYourCarBrand: "Select Your Car Brand",
      chooseFromOurList: "Choose from our list of supported brands",
      search: "Search",
    },
    year: {
      manufacturingYear: "Manufacturing Year",
      whenWasYourCarManufactured: "When was your car manufactured?",
    },
    model: {
      selectCarModel: "Select Car Model",
      chooseYourModel: (car: string) => `Choose your ${car} model`,
    },
    variants: {
      engineSpecifications: "Engine & Specifications",
      TellUsAboutYour: "Tell us about your car's powerhouse",
      transmissionType: "Transmission Type",
      selectVariant: "Select Variant",
      color: "Enter Your Car’s Color",
    },
    kmDriven: {
      howFarHasItTravelled: "How Far Has It Travelled?",
      enterYourOdometerReading: "Enter your odometer reading",
    },
    sellingTime: {
      whenWouldYouLike: "When Would You Like to Sell?",
      chooseYourPreferredTimeline: "Choose your preferred timeline",
    },
    carInfo: {
      tellUsAboutYourCar: "Tell Us About Your Car",
      fillInYourCarsDetails:
        "Fill in your car’s details to help buyers know exactly what you’re offering",
      insurance: "Insurance",
      insuranceAvailable: "Insurance Available",
      yes: "Yes",
      no: "No",
      insuranceType: "Insurance Type",
      comprehensive: "Comprehensive",
      thirdParty: "Third - Party",
      expiryDate: "Expiry Date",
      anyClaimsMade: "Any Claims Made?",
      ownershipRC: "Ownership & RC",
      usageType: "Usage Type",
      personal: "Personal",
      commercial: "Commercial",
      rcAvailable: "RC Available",
      loanHyonthecation: "Loan /Hyonthecation",
      accidentAndServiceHistory: "Accident And Service History",
      accidentHistory: "Accident History",
      accidentFree: "Accident Free",
      minor: "Minor",
      major: "Major",
      fullServiceRecords: "Full Service Records",
      carCondition: "Car Condition",
      excellent: "Excellent",
      good: "Good",
      average: "Average",
      needsWork: "Needs Work",
    },
    images: {
      uploadCarPhotos: "Upload Car Photos",
      showYourCarFrom:
        "Show your car from every angle. Upload clear pictures to increase trust and selling chances.",
      frontView: "Front View",
      backView: "Back View",
      leftSideView: "Left Side View",
      rightSideView: "Right Side View",
      interiorDashboard: "Interior Dashboard",
      odometerReading: "Odometer Reading",
    },
    mobileInfo: {
      letsConnect: "Let's Connect!",
      enterYourNumberto: "Enter your number to receive your car's valuation",
      name: "Name",
      email: "Email",
      phoneNumber: "Phone Number",
      enterOTP: "Enter OTP",
    },
    carValuation: {
      carValuationSummary: "Car Valuation Summary",
      reviewYourDetailsAndEstimatedPrice:
        "Review your details and estimated price",
      vehicleInformation: "Vehicle Information:",
      carNumber: "Car Number:",
      brand: "Brand:",
      model: "Model:",
      year: "Year:",
      specification: "Specification:",
      fuelType: "Fuel Type:",
      transmission: "Transmission:",
      variant: "Variant:",
      kilometers: "Kilometers:",
      sellingDetails: "Selling Details:",
      sellTimeline: "Sell Timeline:",
      phoneNumber: "Phone number:",
      estimatedCarPrice: "Estimated Car Price",
      finalPriceSubjectToPhysicalInspection:
         "After reviewing your car details, we realized your vehicle holds more than just value — it carries memories and emotions. Our experts will soon share the best resale value for your car.",
      confirmation: "Confirmation",
      ourTeamWillCallYouShortly:
        "Our team will call you shortly and visit to check your car before finalizing the deal.",
      serviceAvailability: "Service Availability",
      thisServiceIsOnlyAvailable:
        "This service is only available in Bangalore location",
      only1stOwnerCarsAre: "Only 1st Owner cars are eligible for selling",
    },
  },
  numbersBanner: {
    factsInNumber: "Facts In Number",
    ourNumberSpeakFor: "Our numbers speak for our trust.",
    fromThousandOfVerified:
      "From thousands of verified cars to happy buyers across India — experience the difference with us.",
  },
  testimonial: {
    whatOurClientSay: "What our client say",
  },
  myOrders: {
    myOrders: "My Orders",
  },
  wishlist: {
    wishlist: "Wishlist",
    noProductsFound: "No Products Found in Wishlist",
    noProductsFoundInMyOrders: "No Products Found in My Orders",
  },
  landingPage: {
    getReadyForOur: "Get Ready for Our Next Big Arrival",
    getInTouchWith: "Get in touch with us",
    philosophy: "Philosophy",
    ourPhilosophyEncompasses:
      "Our philosophy encompasses serving, caring, and growing with society. We strive to provide all our customers with the highest level of comfort, safety, and reliability while bringing the joy of driving to all.",
    ourfounderValues:
      "Our founder’s values have now evolved over the years under the management of Mrs. Jyothi M – Dealer Principal & Mr. Mahesh Kumar M – CEO, and the remarkable KAIZEN MOTOR family. We pledge to listen to our customers’ demands and meet all their needs while constantly innovating to remain market leaders in the industry.",
    KAIZENMOTORPractices:
      "KAIZEN MOTOR practices Kaizen, which is the Japanese philosophy of continuous improvement. We believe in satisfying our customers and staying ahead of time to meet the Present & Next generation’s expectations. This is demonstrated through our state-of-the-art Facility, Quality training programs, and innovative approach to business development.",
    KAIZENMOTORHasRecognised:
      "KAIZEN MOTOR has recognised the present challenges in the automobile sector as the “Challenge of the Millennium”, And we at KAIZEN MOTOR work towards Customer Needs, Requirements and Affordable.",
  },
};
